export default "__VITE_ASSET___c8J5efX__"